import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { Store } from '@ngrx/store';
import { CarEngine } from 'src/app/public/car/models/car-engine.model';
import { CarManufacturer } from 'src/app/public/car/models/car-manufacturer.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBasicData } from 'src/app/public/car/constants/car-basic-data';


@Component({
    selector: 'app-carref-engines',
    templateUrl: './carref-engines.component.html',
    styleUrl: './carref-engines.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarrefEnginesComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() manufacturers: CarManufacturer[] = [];
  @Input() engines: CarEngine[] = [];

  carFuelTypes = CarBasicData.fuelTypes;

  newItem: CarEngine = new CarEngine('', '');
  editedItem: CarEngine = new CarEngine('', '');

  displayedColumns: string[] = ['id', 'manufacturerName', 'name', 'fuel', 'powerKw', 'powerHp', 'lastUpdated', 'actions'];
  dataSource = new MatTableDataSource<CarEngine>(this.engines);

  @ViewChild(MatPaginator) paginator! : MatPaginator;
  @ViewChild(MatSort) sort! : MatSort;

  editingItemId: number = 0;
  editingItem: boolean = false;

  constructor(
    private store: Store){
  
  }

  ngOnInit(){
    this.store.dispatch (CarRefActions.enginesFetchSubmit({}));
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['engines']){
      this.dataSource.data = changes['engines'].currentValue;
      
    }
  }

  applyFilter(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }
  
  addNewRow(){
    //const newManuf = new CarEngine('','',false);
    if(! (this.editingItem  && this.editingItemId === 0)){
      this.editedItem = new CarEngine('','');
      this.dataSource.data = [...this.dataSource.data, new CarEngine('','')];
      this.editingItemId = 0;
      this.editingItem = true;
    }
    
  }

  editItem(id: number){
    this.editingItemId = id;
    this.editingItem = true;
    //console.log(this.engines.find((manuf: CarEngine) => manuf.id === id));
    this.editedItem = Object.assign({}, this.editedItem, this.engines.find((item: CarEngine) => item.id === id) );
    //console.log(this.editedItem);
  }

  SaveItem(id: number){
    this.editingItemId = 0;
    this.editingItem = false;
    //console.log(this.editedItem);
    //console.log(this.engines.find((manuf: CarEngine) => manuf.id === id));
    this.editedItem = Object.assign({}, this.engines.find((manuf: CarEngine) => manuf.id === id), this.editedItem);
    
    console.log(this.editedItem);
  
    if(id===0){
      this.store.dispatch (CarRefActions.engineNewSubmit({engine: this.editedItem }));
    } else{
      this.editedItem.id=id;
      console.log(this.editedItem);
      this.store.dispatch (CarRefActions.engineUpdateSubmit({engine: this.editedItem }));
    }
    
  }

  deleteItem(id: number){
    console.log(id)
    if(id ===0 || this.editingItem){
      this.dataSource.data = this.dataSource.data.filter(manuf => manuf.id !== 0);
      this.editingItem = false;
      this.editingItemId === 0
    }
      else{
        this.store.dispatch (CarRefActions.engineDeleteSubmit({engineId: id }));
    }
    
  }

  editedItemIsValid(): boolean{
    return this.editedItem.manufacturerId > 0 && this.editedItem.name.length > 0;
   }

  dateTimeFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

}
